import {
  Box,
  Text,
  Input,
  Button,
  Stack,
  Center,
  SimpleGrid,
  Heading,
  Flex,
  RadioGroup,
  Radio,
} from "@chakra-ui/react";

import BaseLayout from "../../components/base_layout";
import React, { useState, useEffect, useCallback } from "react";
import { getUserInfo, isMemberCheck } from "../../provider/auth";
import { getMainCarrier } from "@sentry/hub";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { GetCookie } from "../../provider/common";

// 전역변수
const axios = require("axios").default;
const MASTER_URL = process.env.MASTER_URL;

export default function OrderNum() {
  const [orderNum, setOrderNum] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {}, []);

  // 주문내역 데이터 불러오기
  const checkEmail = async () => {
    const URL = MASTER_URL + `/api/v2/order/${orderNum}`;
    const res = await axios.get(URL, {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${await GetCookie("token")}`,
      },
    });
    if (res.data.msg === "no data") {
      alert("잘못된 주문번호 입니다.");
      setEmail("");
      setOrderNum("");
      return;
    } else {
      if (res.data.data.od_email !== email) {
        alert("주문번호에 맞는 이메일이 아닙니다.");
        setEmail("");
        setOrderNum("");
        return;
      } else {
        return true;
      }
    }
  };

  const handleOrderInfo = async () => {
    event.preventDefault();
    if ((await checkEmail()) === true) {
      window.location.href = `/mypage/order/${orderNum}`;
      return;
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "orderNum":
        setOrderNum(value);
        break;
    }
  };
  return (
    <BaseLayout>
      <Box className="ordernum-main flex-center">
        <form className="ordernum-form" onSubmit={() => handleOrderInfo()}>
          <label htmlFor="email" className="">
            이메일
            <input
              name="email"
              required
              value={email}
              onChange={onChange}
              className="orderNum-input "
              type="email"
              id="email"
              placeholder="이메일을 입력하세요"
            />
          </label>
          <label htmlFor="orderNumber" className="">
            주문번호
            <input
              name="orderNum"
              required
              value={orderNum}
              onChange={onChange}
              className="orderNum-input "
              type="number"
              id="orderNumber"
              placeholder="주문번호를 입력하세요"
            />
          </label>
          <button className="flex-center">
            <div className="orderNum-btn flex-center">비회원 주문확인</div>
          </button>
        </form>
      </Box>
    </BaseLayout>
  );
}
